<template>
  <v-flex>
    <v-card>
      <v-card-text>

        <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                CNPJ e Registro SUSEP
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 
              <span style="color: #737a82;font-size: 20px;">
                Com base no seu CNPJ e Registro SUSEP, encontramos os dados abaixo. Confira as informações, fazendo atualizações se necessário e prossiga no cadastro da Corretora.
              </span>
              <br />
              <br />


              <div class="flex-col-12">
                <div class="flex-row">

                  <div class="flex-col-2">
                    
                    <v-text-field
                      v-model="corretor.Susep"
                      label="Registro SUSEP"
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-2">
                    <v-text-field
                      v-model="corretor.SusepStatus"
                      label="Situação"
                      disabled
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>
                
                <div class="flex-row">

                  <div class="flex-col-2">
                    <v-text-field
                      v-model="corretor.Cnpj"
                      label="CNPJ"
                      v-mask="mascaraCnpj"
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </div>
                  
                  <div class="flex-col-5">
                    <v-text-field
                      label="Razão Social"
                      v-model="corretor.RazaoSocial"
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-5">
                    <v-text-field
                      v-model="corretor.NomeFantazia"
                      label="Nome Fantasia"
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>

                <div class="flex-row">                 
                  <div class="flex-col-2">
                    <v-text-field
                      v-model="corretor.CNAE"
                      label="Código CNAE"
                      outlined
                      v-on:blur="pesquisarCnae"
                      v-mask="'#######'"
                    >
                    </v-text-field>
                  </div>
                  <div class="flex-col-8">
                    <v-text-field
                      v-model="corretor.CNAEDescricao"
                      label="Descrição CNAE"
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </div>   

                  <div class="flex-col-2">
                    <v-select
                      v-model="corretor.NumeroFuncionario"
                      :items="listNumeroFuncionario"
                      :value="corretor.NumeroFuncionario"
                      item-value='id'
                      item-text='descricao'
                      label="Número de Funcionários"
                      outlined
                    ></v-select>
                  </div>        

                </div>

                <div class="flex-row">

                  <div class="flex-col-2">
                    <v-text-field
                      v-model="corretor.EnderecoCep"
                      label="Endereço Cep"
                      v-mask="'#####-###'"
                      outlined
                    >
                    </v-text-field>
                  </div>
                  <v-flex xs12 sm4 md2>
                    <v-btn rounded color="info" @click="buscarCep">
                      <v-icon left dark>search</v-icon>
                      Pesquisar
                    </v-btn>
                  </v-flex>

                </div>

                <div class="flex-row">

                  <div class="flex-col-8">
                    <v-text-field
                      v-model="corretor.EnderecoRua"
                      label="Endereço"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.EnderecoNumero"
                      label="Endereço Número"
                      outlined
                    >
                    </v-text-field>
                  </div>

                </div>

                <div class="flex-row">

                  <div class="flex-col-6">
                    <v-text-field
                      v-model="corretor.EnderecoBairro"
                      label="Endereço Bairro"
                      outlined
                    >
                    </v-text-field>
                  </div>
                  
                  <div class="flex-col-6">
                    <v-text-field
                      v-model="corretor.EnderecoComplemento"
                      label="Endereço Complemento"
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>    

                <div class="flex-row">

                  <div class="flex-col-6">
                    <v-text-field
                      v-model="corretor.EnderecoCidade"
                      label="Endereço Cidade"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-6">
                    <v-select
                      v-model="corretor.EnderecoEstado"
                      :items="listEnderecoEstado"
                      :value="corretor.EnderecoEstado"
                      item-value='id'
                      item-text='descricao'
                      label="Endereço Estado"
                      outlined
                    ></v-select>
                  </div>
                </div>                             

              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>  

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Tipo de Produto
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 

              <span style="color: #737a82;font-size: 20px;">
                Arraste para o lado identificando até 8 produtos mais comercializados pela sua corretor.
              </span>
              <br />
              <br />
              
              <div class="flex-col-12">
                <div class="flex-row">

                  <div class="flex-col-6">
                    <span style="color: #007ca5;font-size: 12px">
                      Tipos de Produto
                    </span>

                    <draggable class="list-group" :list="listTipoProduto" group="people">
                      <div
                        v-for="(itemTipoProduto) in listTipoProduto"
                        :key="itemTipoProduto.Descricao"
                      >
                        <v-chip
                          class="ma-2"
                          color="primary"
                          :style="`cursor: pointer !important;`"
                        >
                          {{ itemTipoProduto.Descricao }}
                        </v-chip>
                        <br />
                      </div>
                    </draggable>

                  </div>

                  <div class="flex-col-6">
                    <span style="color: #007ca5;font-size: 12px">
                      Tipos Selecionados
                    </span>
                    <draggable class="list-group" :list="listTipoProdutoSelecionado" group="people" >
                      <div
                        v-for="(itemTipoProduto, index) in listTipoProdutoSelecionado"
                        :key="itemTipoProduto.Descricao"
                      >
                        <v-chip
                          class="ma-2"
                          color="success"
                          :style="`cursor: pointer !important;`"
                        >
                          <v-avatar left>
                            <span style="border-radius: 10px; background-color:white; width: 20px; height: 18px; color: gray;">{{ index + 1 }}</span>
                          </v-avatar>
                          {{ itemTipoProduto.Descricao }}
                        </v-chip>
                        <br />
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Multicálculo e Redes Sociais
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 
              <span style="color: #737a82;font-size: 20px;">
                Queremos conhecer melhor a forma de trabalhar da Corretora. Para isso, contamos com seu apoio para preenchimento das informações abaixo:
              </span>
              <br />
              <br />

              <div class="flex-col-12">
                <div class="flex-row">
                  
                  <div class="flex-col-4">
                    <v-select
                      v-model="corretor.UtilizaMulticalculo"
                      :items="listSimNao"
                      v-on:change="onChangeUtilizaMulticalculo()"                      
                      item-value='id'
                      item-text='descricao'                      
                      label="Utiliza multicálculo? *"
                      outlined
                    ></v-select>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.MulticalculoTipo"
                      :readonly="disabledMultiCalculo"
                      label="Qual Multicálculo*"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-select
                      v-model="corretor.ContatoPreferencia"
                      :items="listPreferenciaContato"
                      item-value='id'
                      item-text='descricao' 
                      label="Prefere ser contatado preferencialmente por *"
                      outlined
                    ></v-select>
                  </div>
                </div>

                <div class="flex-row">
                  
                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.Linkedin"
                      label="Linkedin"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.Facebook"
                      label="Facebook"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.Instagram"
                      label="Instagram"
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>

                <div class="flex-row">
                  
                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.Twitter"
                      label="Twitter"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      v-model="corretor.SiteCorretora"
                      label="Site"
                      outlined
                    >
                    </v-text-field>
                  </div>

                </div>

              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>  

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Dados Financeiros 
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 
              <span style="color: #737a82;font-size: 20px;">
                Preencha os dados bancários para recebimento de comissões:
              </span>
              <br />
              <br />


              <div class="flex-col-12">
                <div class="flex-row">
                  <div class="flex-col-3">
                    <v-autocomplete
                      v-model="corretor.Banco"
                      :items="listBanco"
                      item-text="descricao"
                      item-value="id"
                      label="Banco *"
                    ></v-autocomplete>                  
                  <!-- 
                    <v-select
                      :items="listBanco"
                      item-value='id'
                      item-text='descricao'     
                      v-model="corretor.Banco"                  
                      label="Banco *"
                      outlined
                    ></v-select> -->
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      label="Agência *"
                      v-model="corretor.BancoAgencia"
                      v-mask="'##########'"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      label="Conta Corrente *"
                      v-model="corretor.BancoContaCorrente"
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>

                <div class="flex-row">
                  
                  <div class="flex-col-3">
                    <v-select
                      v-model="corretor.AliquotaSimplesNacional"
                      :items="listSimNao"
                      v-on:change="onChangeAliquotaSimplesNacional()"                      
                      item-value='id'
                      item-text='descricao' 
                      label="Optante  Simples Nacional? *"
                      outlined
                    ></v-select>
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      v-model="corretor.AliquotaEnquadramentoISSQN"
                      label="Se optante, informar Alíquiota *"
                      :disabled="disabledAliquotaSimplesNacional"
                      v-mask="'##,##'"
         
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-select
                      v-model="corretor.BancoFormaDePagamento"
                      :items="listBancoFormaDePagamento"
                      item-value='id'
                      item-text='descricao' 
                      label="Forma de pagamento"
                      outlined
                    ></v-select>
                  </div>                  

                </div>

              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>  

        </v-expansion-panels>         

      </v-card-text>

      <v-card-actions :style="`background-color: rgba(243, 243, 243, 0.25) !important; border-top: 1px black !important;`">
        <v-spacer></v-spacer>
        <v-btn 
          :style="`background-color:#7fbdd2 !important; width: 106px !important; height: 35px !important; border-radius: 4px !important;`" 
          class="white--text" 
          @click="salvarDados()"
        >
          PRÓXIMO
        </v-btn>
        
      </v-card-actions>
    </v-card>
  </v-flex>
  
</template>


<script>
import Helpers from "@/utilities/Helpers";
import Vue from 'vue';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';

export default {
  mixins: [Helpers], 
  components: {
      draggable,
  },

  name: "CorretorDegustacaoDadosCorretor",

  props: ["ativarAba"],

  computed: {
  ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
  }, 

  created() {
    setTimeout(() => {
      this.CarregarCorretorDegustacao();
    }, 1000);
  },

  methods: {    

    onChangeUtilizaMulticalculo(){
      this.disabledMultiCalculo = !this.corretor.UtilizaMulticalculo == true;
      this.corretor.MulticalculoTipo = "";
    },
    
    onChangeAliquotaSimplesNacional(){
      this.disabledAliquotaSimplesNacional = !this.corretor.AliquotaSimplesNacional == true;
      this.corretor.AliquotaEnquadramentoISSQN = 0;
    },

    onLoadProdutoSelecionados(){
        let deleleIndex = [];

        for (let produtoIndex = 0; produtoIndex < this.listTipoProduto.length; produtoIndex++) {
          const produto = this.listTipoProduto[produtoIndex];

          for (let index = 0; index < this.corretor.Produtos.length; index++) {
            const corretorProduto = this.corretor.Produtos[index];
            if(produto.Descricao == corretorProduto.Descricao){
                deleleIndex.push(produtoIndex);
            }                
          }              
        }
        this.$delete(this.listTipoProduto,deleleIndex);
    },

    pesquisarCnae: function() {   //CNAE valido: 8211300
      if(this.corretor.CNAE == "0"){
        this.corretor.CNAEDescricao = "";
        return;
      }

      this.$httpPbs.get('classificacao/AtividadeTecnica/' + this.corretor.CNAE).then(response => {

        let cnae = response.data.data;

        if(cnae != null) {
          this.corretor.CNAEDescricao = cnae.nomeRamoAtividade;
          return;
        }
        this.showToast("error", "Erro", "CNAE não encontrado no sistema.");
        
      }).catch( error => {
          console.log(error.response);
          this.showToast("error", "Erro", "CNAE não encontrado.");
      });      
    },

    salvarDados(){
      this.corretor.Etapa = 2//Dados Cadastrais
      this.corretor.Produtos = this.listTipoProdutoSelecionado;

      this.ativarAba(1, this.corretor)
    },

    CarregarCorretorDegustacao()
    {
      this.fullLoading = true;     
      this.loading = true;

      let codigoCorretor = this.usuario.codCorretor;

      let url = "CorretorDegustacao/Selecionar?id="+codigoCorretor;

      Vue.prototype.$httpPortal.get(url)
      .then(res => {
          let dataRequest = res.data;
          console.log(res.data);

          if(!dataRequest.Sucesso){
            // this.showToast("error", "Erro", "Erro ao carregar os dados do corretor.");
            this.loading = false;
            this.fullLoading = false;
          }

          let corretorDegustacao = dataRequest.ObjetoRetorno;
          corretorDegustacao.CNAEDescricao = "";
          this.loading = false;
          this.fullLoading = false;
          this.corretor = corretorDegustacao;
          this.listTipoProdutoSelecionado = this.corretor.Produtos;  

          // this.onChangeUtilizaMulticalculo();
          this.disabledMultiCalculo = !this.corretor.UtilizaMulticalculo == true;

          this.onChangeAliquotaSimplesNacional();
          this.onLoadProdutoSelecionados();
          
      })
      .catch(ex => {
          console.log(ex);
          this.showToast("error", "Erro", "Ocorreu um problema ao carregar os dados do corretor.");
          this.loading = false;
          this.fullLoading = false;
      }); 
    },

    buscarEstado(sigla) {
      
      let idEstado = 0;

      this.listEnderecoEstado.forEach(itemEstado => {

        if (itemEstado.sigla === sigla) {
          idEstado = itemEstado.id;
        }
      });

      return idEstado;
    },
    
    buscarCep: function() {
      const cep = this.corretor.EnderecoCep.replace("-", "");

      if (this.isCep(cep) == false) {
        this.showToast("error", "Erro!", "O CEP " + cep + " é inválido.");
        return;
      }

      this.fullLoading = true;

      this.obterEndereco(cep).then(response => {

        let _endereco = response.data.data;

        this.corretor.EnderecoRua = _endereco.Logradouro;
        this.corretor.EnderecoCidade = _endereco.Localidade;
        this.corretor.EnderecoBairro = _endereco.Bairro;
        this.corretor.EnderecoEstado = this.buscarEstado(_endereco.UF);

        this.fullLoading = false;

        return response;
      })
      .catch(error => {
        console.log(error);
        this.fullLoading = false;
      });
    }
  },

  data() {
    return {
      panel: 0,
      corretor: null,
      disabledMultiCalculo: false,
      disableAliquotaSimplesNacional: false,
      listTipoProdutoSelecionado: [],
      listTipoProduto: [ ///Nao alterar a descrição sem validar no enum, pois a SalesForce deixa apenas os pre-cadastrados
          { id: 1,  Descricao: 'Automóvel' },
          { id: 2,  Descricao: 'Crédito Interno' },
          { id: 3,  Descricao: 'Educacional' },
          { id: 4,  Descricao: 'Empresarial' },
          { id: 5,  Descricao: 'Eventos' },
          { id: 6,  Descricao: 'Fiança Locatícia' },
          { id: 7,  Descricao: 'Garantia' },
          { id: 8,  Descricao: 'Habitacional' },
          { id: 9,  Descricao: 'Marítimos Aeronáuticos' },
          { id: 10, Descricao: 'Microsseguros' },
          { id: 11, Descricao: 'Patrimonial Diversos' },
          { id: 12, Descricao: 'Prestamista' },
          { id: 13, Descricao: 'Residencial' },
          { id: 14, Descricao: 'Responsabilidades' },
          { id: 15, Descricao: 'Riscos Especiais' },
          { id: 16, Descricao: 'Riscos Financeiros Diversos' },
          { id: 17, Descricao: 'Rural' },
          { id: 18, Descricao: 'Saúde Odonto' },
          { id: 19, Descricao: 'Transportes' },
          { id: 20, Descricao: 'Viagem' },
          { id: 21, Descricao: 'Vida AP Coletivo' },
          { id: 22, Descricao: 'Vida AP Individual' },

      ],
      listNumeroFuncionario: [
        { id: 0, descricao: '' },
        { id: 1, descricao: 'Ate 49 funcionários' },
        { id: 2, descricao: 'De 50 a 99 funcionários' },
        { id: 3, descricao: 'Acima de 99 funcionários' },
      ],
      listSimNao: [
        { id: true, descricao: 'Sim' },
        { id: false, descricao: 'Não' },
      ] ,
      listPreferenciaContato: [
        { id: 0, descricao: '' },
        { id: 1, descricao: 'E-mail' },
        { id: 2, descricao: 'Telefone' },
        { id: 3, descricao: 'WhatsApp' },
      ],
      listBanco: [
        { id: 0, descricao: '' },
        { id: 246, descricao: '246 - Banco ABC Brasil S.A.' },
        { id: 75, descricao: '075 - Banco ABN AMRO S.A.' },
        { id: 121, descricao: '121 - Banco Agibank S.A.' },
        { id: 25, descricao: '025 - Banco Alfa S.A.' },
        { id: 641, descricao: '641 - Banco Alvorada S.A.' },
        { id: 65, descricao: '065 - Banco Andbank (Brasil) S.A.' },
        { id: 96, descricao: '096 - Banco B3 S.A.' },
        { id: 24, descricao: '024 - Banco BANDEPE S.A.' },
        { id: 318, descricao: '318 - Banco BMG S.A.' },
        { id: 752, descricao: '752 - Banco BNP Paribas Brasil S.A.' },
        { id: 107, descricao: '107 - Banco BOCOM BBM S.A.' },
        { id: 63, descricao: '063 - Banco Bradescard S.A.' },
        { id: 36, descricao: '036 - Banco Bradesco BBI S.A.' },
        { id: 204, descricao: '204 - Banco Bradesco Cartões S.A.' },
        { id: 394, descricao: '394 - Banco Bradesco Financiamentos S.A.' },
        { id: 237, descricao: '237 - Banco Bradesco S.A.' },
        { id: 218, descricao: '218 - Banco BS2 S.A.' },
        { id: 208, descricao: '208 - Banco BTG Pactual S.A.' },
        { id: 473, descricao: '473 - Banco Caixa Geral - Brasil S.A.' },
        { id: 40, descricao: '040 - Banco Cargill S.A.' },
        { id: 739, descricao: '739 - Banco Cetelem S.A.' },
        { id: 233, descricao: '233 - Banco Cifra S.A.' },
        { id: 745, descricao: '745 - Banco Citibank S.A.' },
        { id: 756, descricao: '756 - Banco Cooperativo do Brasil S.A. - BANCOOB' },
        { id: 748, descricao: '748 - Banco Cooperativo Sicredi S.A.' },
        { id: 222, descricao: '222 - Banco Credit Agricole Brasil S.A.' },
        { id: 505, descricao: '505 - Banco Credit Suisse (Brasil) S.A.' },
        { id: 3, descricao: '003 - Banco da Amazônia S.A.' },
        { id: 83, descricao: '083 -Banco da China Brasil S.A.' },
        { id: 707, descricao: '707 - Banco Daycoval S.A.' },
        { id: 1, descricao: '001 - Banco do Brasil S.A.' },
        { id: 47, descricao: '047 - Banco do Estado de Sergipe S.A.' },
        { id: 37, descricao: '037 - Banco do Estado do Pará S.A.' },
        { id: 41, descricao: '041 - Banco do Estado do Rio Grande do Sul S.A.' },
        { id: 4, descricao: '004 - Banco do Nordeste do Brasil S.A.' },
        { id: 265, descricao: '265 - Banco Fator S.A.' },
        { id: 224, descricao: '224 - Banco Fibra S.A.' },
        { id: 626, descricao: '626 - Banco Ficsa S.A.' },
        { id: 94, descricao: '094 - Banco Finaxis S.A.' },
        { id: 612, descricao: '612 - Banco Guanabara S.A.' },
        { id: 12, descricao: '012 - Banco Inbursa S.A.' },
        { id: 604, descricao: '604 - Banco Industrial do Brasil S.A.' },
        { id: 653, descricao: '653 - Banco Indusval S.A.' },
        { id: 77, descricao: '077 - Banco Inter S.A.' },
        { id: 249, descricao: '249 - Banco Investcred Unibanco S.A.' },
        { id: 184, descricao: '184 - Banco Itaú BBA S.A.' },
        { id: 29, descricao: '029 Banco Itaú Consignado S.A.' },
        { id: 479, descricao: '479 - Banco ItauBank S.A' },
        { id: 376, descricao: '376 - Banco J. P. Morgan S.A.' },
        { id: 74, descricao: '074 - Banco J. Safra S.A.' },
        { id: 217, descricao: '217 - Banco John Deere S.A.' },
        { id: 600, descricao: '600 - Banco Luso Brasileiro S.A.' },
        { id: 389, descricao: '389 - Banco Mercantil do Brasil S.A.' },
        { id: 370, descricao: '370 - Banco Mizuho do Brasil S.A.' },
        { id: 746, descricao: '746 - Banco Modal S.A.' },
        { id: 456, descricao: '456 - Banco MUFG Brasil S.A.' },
        { id: 169, descricao: '169 - Banco Olé Bonsucesso Consignado S.A.' },
        { id: 212, descricao: '212 - Banco Original S.A.' },
        { id: 623, descricao: '623 - Banco PAN S.A.' },
        { id: 611, descricao: '611 - Banco Paulista S.A.' },
        { id: 643, descricao: '643 - Banco Pine S.A.' },
        { id: 747, descricao: '747 - Banco Rabobank International Brasil S.A.' },
        { id: 633, descricao: '633 - Banco Rendimento S.A.' },
        { id: 120, descricao: '120 - Banco Rodobens S.A.' },
        { id: 422, descricao: '422 - Banco Safra S.A.' },
        { id: 33, descricao: '033 - Banco Santander (Brasil) S.A.' },
        { id: 743, descricao: '743 - Banco Semear S.A.' },
        { id: 630, descricao: '630 - Banco Smartbank S.A.' },
        { id: 366, descricao: '366 - Banco Société Générale Brasil S.A.' },
        { id: 464, descricao: '464 - Banco Sumitomo Mitsui Brasileiro S.A.' },
        { id: 82, descricao: '082 - Banco Topázio S.A.' },
        { id: 634, descricao: '634 - Banco Triângulo S.A.' },
        { id: 655, descricao: '655 - Banco Votorantim S.A.' },
        { id: 610, descricao: '610 - Banco VR S.A.' },
        { id: 119, descricao: '119 - Banco Western Union do Brasil S.A.' },
        { id: 102, descricao: '102 - Banco XP S.A.' },
        { id: 81, descricao: '081 - BancoSeguro S.A.' },
        { id: 21, descricao: '021 - BANESTES S.A. Banco do Estado do Espírito Santo' },
        { id: 755, descricao: '755 - Bank of America Merrill Lynch Banco Múltiplo S.A.' },
        { id: 250, descricao: '250 - BCV - Banco de Crédito e Varejo S.A.' },
        { id: 144, descricao: '144 - BEXS Banco de Câmbio S.A.' },
        { id: 17, descricao: '017 - BNY Mellon Banco S.A.' },
        { id: 70, descricao: '070 - BRB - Banco de Brasília S.A.' },
        { id: 104, descricao: '104 - Caixa Econômica Federal' },
        { id: 320, descricao: '320 - China Construction Bank (Brasil) Banco Múltiplo S.A.' },
        { id: 477, descricao: '477 - Citibank N.A.' },
        { id: 487, descricao: '487 - Deutsche Bank S.A. - Banco Alemão' },
        { id: 64, descricao: '064 - Goldman Sachs do Brasil Banco Múltiplo S.A.' },
        { id: 62, descricao: '062 - Hipercard Banco Múltiplo S.A.' },
        { id: 269, descricao: '269 - HSBC Brasil S.A. - Banco de Investimento' },
        { id: 492, descricao: '492 - ING Bank N.V.' },
        { id: 652, descricao: '652 - Itaú Unibanco Holding S.A.' },
        { id: 341, descricao: '341 - Itaú Unibanco S.A.' },
        { id: 488, descricao: '488 - JPMorgan Chase Bank, National Association' },
        { id: 399, descricao: '399 - Kirton Bank S.A. - Banco Múltiplo' },
        { id: 128, descricao: '128 - MS Bank S.A. Banco de Câmbio' },
        { id: 254, descricao: '254 - Paraná Banco S.A.' },
        { id: 125, descricao: '125 - Plural S.A. - Banco Múltiplo' },
        { id: 751, descricao: '751 - Scotiabank Brasil S.A. Banco Múltiplo' },
        { id: 95, descricao: '095 - Travelex Banco de Câmbio S.A.' },
        { id: 129, descricao: '129 - UBS Brasil Banco de Investimento S.A.' },
      ]  ,

      listBancoFormaDePagamento: [
        { id: 0, descricao: '' },
        { id: 1, descricao: 'Cheque' },
        { id: 2, descricao: 'Credito em Conta' },
        { id: 3, descricao: 'Documento bancario' },
      ],  

      listMulticalculoTipo: [
        { id: 0, descricao: '' },
        { id: 1, descricao: 'Aggilizador' },
        { id: 2, descricao: 'SegFy' },
        { id: 3, descricao: 'CorretagemFacil' },
        { id: 4, descricao: 'Moshe' },
        { id: 5, descricao: 'Teleport' },
        { id: 6, descricao: 'SGCOR' },
        { id: 7, descricao: 'EBIX' },
      ],  

      listEnderecoEstado: [
        { id: 0,  sigla: '', descricao: '' },
        { id: 1,  sigla: 'AC', descricao: 'Acre' },
        { id: 2,  sigla: 'AL', descricao: 'Alagoas' },
        { id: 3,  sigla: 'AP', descricao: 'Amapá' },
        { id: 4,  sigla: 'AM', descricao: 'Amazonas' },
        { id: 5,  sigla: 'BA', descricao: 'Bahia' },
        { id: 6,  sigla: 'CE', descricao: 'Ceará' },
        { id: 7,  sigla: 'DF', descricao: 'Distrito Federal' },
        { id: 8,  sigla: 'ES', descricao: 'Espírito Santo' },
        { id: 9,  sigla: 'GO', descricao: 'Goiás' },
        { id: 10, sigla: 'MA', descricao: 'Maranhão' },
        { id: 11, sigla: 'MT', descricao: 'Mato Grosso' },
        { id: 12, sigla: 'MS', descricao: 'Mato Grosso do Sul' },
        { id: 13, sigla: 'MG', descricao: 'Minas Gerais' },
        { id: 14, sigla: 'PA', descricao: 'Pará' },
        { id: 15, sigla: 'PB', descricao: 'Paraíba' },
        { id: 16, sigla: 'PR', descricao: 'Paraná' },
        { id: 17, sigla: 'PE', descricao: 'Pernambuco' },
        { id: 18, sigla: 'PI', descricao: 'Piauí' },
        { id: 19, sigla: 'RJ', descricao: 'Rio de Janeiro' },
        { id: 20, sigla: 'RN', descricao: 'Rio Grande do Norte' },
        { id: 21, sigla: 'RS', descricao: 'Rio Grande do Sul' },
        { id: 22, sigla: 'RO', descricao: 'Rondônia' },
        { id: 23, sigla: 'RR', descricao: 'Roraima' },
        { id: 24, sigla: 'SC', descricao: 'Santa Catarina' },
        { id: 25, sigla: 'SP', descricao: 'São Paulo' },
        { id: 26, sigla: 'SE', descricao: 'Sergipe' },
        { id: 27, sigla: 'TO', descricao: 'Tocantins' },

      ],            
    }
  }
  
}
</script>
